import { singleton } from "./fable_modules/fable-library.3.7.14/AsyncBuilder.js";
import { Texture } from "./Model.Platform.fs.js";
import { sleep } from "./fable_modules/fable-library.3.7.14/Async.js";
import { value as value_1 } from "./fable_modules/fable-library.3.7.14/Option.js";
import { append, map, contains, fill } from "./fable_modules/fable-library.3.7.14/Array.js";
import { iterate, length } from "./fable_modules/fable-library.3.7.14/Seq.js";
import { isShareware, isSharewareSprite } from "./Assets.fs.js";
import { structuralHash, equals } from "./fable_modules/fable-library.3.7.14/Util.js";
import { printf, toText } from "./fable_modules/fable-library.3.7.14/String.js";
import { rangeDouble } from "./fable_modules/fable-library.3.7.14/Range.js";
import { StatusBarGraphics } from "./Model.fs.js";
import { setPixel, getPixel } from "./Graphics.Common.fs.js";

export function spriteColorIsTransparent(color) {
    if (color === 4287234202) {
        return true;
    }
    else {
        return color === 0;
    }
}

export function scaleSprite(_arg2, _arg1, image) {
    return image;
}

export function loadTexture(name, textureWidth, textureHeight) {
    return singleton.Delay(() => {
        let imageData = void 0;
        let image;
        try {
            let returnVal = new Image(textureWidth, textureHeight);
            returnVal.src = name;
            returnVal.onerror = ((_arg1) => {
                const canvas = window.document.createElement("canvas");
                canvas.width = textureWidth;
                canvas.height = textureHeight;
                const context = canvas.getContext('2d');
                const buffer = context.getImageData(0, 0, textureWidth, textureHeight).data.buffer;
                imageData = (new Texture(new Uint32Array(buffer), new Uint8ClampedArray(buffer), canvas, ~(~textureWidth), ~(~textureHeight)));
            });
            image = returnVal;
        }
        catch (matchValue) {
            let returnVal_1 = new Image(textureWidth, textureHeight);
            returnVal_1.src = "assets/sprites/SPR00000.png";
            image = returnVal_1;
        }
        const canvas_1 = window.document.createElement("canvas");
        canvas_1.width = image.width;
        canvas_1.height = image.height;
        image.onload = ((_arg2) => {
            const context_1 = canvas_1.getContext('2d');
            context_1.drawImage(image, 0, 0, image.width, image.height);
            const buffer_1 = context_1.getImageData(0, 0, image.width, image.height).data.buffer;
            imageData = (new Texture(new Uint32Array(buffer_1), new Uint8ClampedArray(buffer_1), canvas_1, ~(~image.width), ~(~image.height)));
        });
        return singleton.Combine(singleton.While(() => (imageData == null), singleton.Delay(() => singleton.Bind(sleep(500), () => singleton.Return()))), singleton.Delay(() => singleton.Return(value_1(imageData))));
    });
}

export function loadTextureSet(nameFormatter, fallbackName, textureWidth, textureHeight, checkShareware, indexes) {
    return singleton.Delay(() => {
        const imageDataArray = fill(new Array(length(indexes)), 0, length(indexes), void 0);
        iterate((index) => {
            let image;
            const spriteFileIndex = ((((!checkShareware) ? true : isSharewareSprite(index)) ? true : (!isShareware)) ? index : 0) | 0;
            try {
                let returnVal = new Image();
                returnVal.src = nameFormatter(spriteFileIndex);
                returnVal.onerror = ((_arg1) => {
                    const canvas = window.document.createElement("canvas");
                    canvas.width = textureWidth;
                    canvas.height = textureHeight;
                    const context = canvas.getContext('2d');
                    const buffer = context.getImageData(0, 0, textureWidth, textureHeight).data.buffer;
                    imageDataArray[index] = (new Texture(new Uint32Array(buffer), new Uint8ClampedArray(buffer), canvas, 64, 64));
                });
                image = returnVal;
            }
            catch (matchValue) {
                let returnVal_1 = new Image(textureWidth, textureHeight);
                returnVal_1.src = fallbackName;
                image = returnVal_1;
            }
            const canvas_1 = window.document.createElement("canvas");
            image.onload = ((_arg2) => {
                canvas_1.width = image.width;
                canvas_1.height = image.height;
                const context_1 = canvas_1.getContext('2d');
                context_1.drawImage(image, 0, 0, image.width, image.height);
                const buffer_1 = context_1.getImageData(0, 0, image.width, image.height).data.buffer;
                imageDataArray[index] = (new Texture(new Uint32Array(buffer_1), new Uint8ClampedArray(buffer_1), canvas_1, ~(~image.width), ~(~image.height)));
            });
        }, indexes);
        return singleton.Combine(singleton.While(() => contains(void 0, imageDataArray, {
            Equals: equals,
            GetHashCode: structuralHash,
        }), singleton.Delay(() => singleton.Bind(sleep(500), () => singleton.Return()))), singleton.Delay(() => singleton.Return(map(value_1, imageDataArray))));
    });
}

export function loadStatusBar(_arg1) {
    return singleton.Delay(() => singleton.Bind(loadTextureSet((i) => {
        const arg10 = (i + 109) | 0;
        return toText(printf("assets/statusBar/PIC%05d.png"))(arg10);
    }, "assets/sprites/SPR00000.png", 24, 32, false, rangeDouble(0, 1, 23)), (_arg2) => {
        const textureSet = _arg2;
        return singleton.Bind(loadTexture("assets/statusBar/background.png", 304, 35), (_arg3) => singleton.Bind(loadTextureSet((i_1) => toText(printf("assets/statusBar/font/%d.png"))(i_1), "assets/sprites/SPR00000.png", 8, 16, false, rangeDouble(0, 1, 9)), (_arg4) => singleton.Bind(loadTexture("assets/statusBar/font/_.png", 8, 16), (_arg5) => singleton.Bind(loadTexture("assets/statusBar/weapons/knife.png", 48, 24), (_arg6) => singleton.Bind(loadTexture("assets/statusBar/weapons/pistol.png", 48, 24), (_arg7) => singleton.Bind(loadTexture("assets/statusBar/weapons/machineGun.png", 48, 24), (_arg8) => singleton.Bind(loadTexture("assets/statusBar/weapons/chainGun.png", 48, 24), (_arg9) => singleton.Return(new StatusBarGraphics(_arg3, [textureSet.slice(0, 2 + 1), textureSet.slice(3, 5 + 1), textureSet.slice(6, 8 + 1), textureSet.slice(9, 11 + 1), textureSet.slice(12, 14 + 1), textureSet.slice(15, 17 + 1), textureSet.slice(18, 20 + 1)], textureSet[21], textureSet[22], textureSet[23], append(_arg4, [_arg5]), [_arg6, _arg7, _arg8, _arg9])))))))));
    }));
}

export function loadSprites() {
    return singleton.Delay(() => singleton.ReturnFrom(loadTextureSet((i) => toText(printf("assets/sprites/SPR%05d.png"))(i), "assets/sprites/SPR00000.png", 64, 64, true, rangeDouble(0, 1, 435))));
}

export function canvasFromTexture(texture) {
    const canvas = window.document.createElement("canvas");
    canvas.width = texture.Width;
    canvas.height = texture.Height;
    const context = canvas.getContext('2d');
    iterate((y) => {
        iterate((x) => {
            if (spriteColorIsTransparent(getPixel(texture, x, y))) {
                setPixel(texture, 255, x, y);
            }
        }, rangeDouble(0, 1, 63));
    }, rangeDouble(0, 1, 63));
    const imageData = new ImageData(texture.ClampedData,texture.Width,texture.Height);
    context.putImageData(imageData, 0, 0);
    return canvas;
}

